import { round2Decimals } from 'helpers/slipHelper';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const use2DecimalsNumberState = (
  defaultValue: number
): [number, Dispatch<SetStateAction<number>>] => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    if (value.toString().split('.')[1]?.length > 2) {
      setValue(round2Decimals(value));
    }
  }, [value]);

  return [value, setValue];
};
